// Plans that render an options selector dropdown (instead of a plain "Add to
// Order" link) in the Add-Ons grid. Each entry maps a plan code to an array
// of {value, label, price} options. Selecting one adds/updates the product
// at that option's price.

// Country-agnostic options (same tiers for all countries).
const PLAN_OPTIONS = {
  'addon-5-keap-addcontacts-m2m': [
    {value: '1000-36', label: 'Up To 1,000 Contacts: $36', price: 36},
    {value: '2500-84', label: 'Up To 2,500 Contacts: $84', price: 84},
    {value: '5000-150', label: 'Up To 5,000 Contacts: $150', price: 150},
    {value: '10000-240', label: 'Up To 10,000 Contacts: $240', price: 240},
    {value: '15000-330', label: 'Up To 15,000 Contacts: $330', price: 330},
    {value: '25000-420', label: 'Up To 25,000 Contacts: $420', price: 420},
    {value: '50000-480', label: 'Up To 50,000 Contacts: $480', price: 480},
    {value: '75000-600', label: 'Up To 75,000 Contacts: $600', price: 600},
    {value: '100000-720', label: 'Up To 100,000 Contacts: $720', price: 720},
    {
      value: '200000-1200',
      label: 'Up To 200,000 Contacts: $1,200',
      price: 1200,
    },
    {
      value: '500000-1980',
      label: 'Up To 500,000 Contacts: $1,980',
      price: 1980,
    },
    {
      value: '750000-2940',
      label: 'Up To 750,000 Contacts: $2,940',
      price: 2940,
    },
    {
      value: '1000000-3720',
      label: 'Up To 1,000,000 Contacts: $3,720',
      price: 3720,
    },
    {
      value: '2000000-5940',
      label: 'Up To 2,000,000 Contacts: $5,940',
      price: 5940,
    },
    {
      value: '3000000-7200',
      label: 'Up To 3,000,000 Contacts: $7,200',
      price: 7200,
    },
    {
      value: '4000000-8460',
      label: 'Up To 4,000,000 Contacts: $8,460',
      price: 8460,
    },
    {
      value: '5000000-10140',
      label: 'Over 4,000,000 Contacts: $10,140',
      price: 10140,
    },
  ],
  'addon-5-keap-textvoice-m2m': [
    {value: '1-14', label: 'Tier 1: $14', price: 14},
    {value: '2-24', label: 'Tier 2: $24', price: 24},
    {value: '3-39', label: 'Tier 3: $39', price: 39},
    {value: '4-79', label: 'Tier 4: $79', price: 79},
    {value: '5-139', label: 'Tier 5: $139', price: 139},
    {value: '6-279', label: 'Tier 6: $279', price: 279},
  ],
}

// Country-specific options — keyed by plan code, then by selectedCountry.
const PLAN_OPTIONS_BY_COUNTRY = {
  'addon-5-keap-addcontacts-annual': {
    US: [
      {value: '1000-346', label: 'Up To 1,000 Contacts: $346', price: 346},
      {value: '2500-792', label: 'Up To 2,500 Contacts: $792', price: 792},
      {
        value: '5000-1440',
        label: 'Up To 5,000 Contacts: $1,440',
        price: 1440,
      },
      {
        value: '10000-2304',
        label: 'Up To 10,000 Contacts: $2,304',
        price: 2304,
      },
      {
        value: '15000-3168',
        label: 'Up To 15,000 Contacts: $3,168',
        price: 3168,
      },
      {
        value: '25000-4032',
        label: 'Up To 25,000 Contacts: $4,032',
        price: 4032,
      },
      {
        value: '50000-4608',
        label: 'Up To 50,000 Contacts: $4,608',
        price: 4608,
      },
      {
        value: '75000-5760',
        label: 'Up To 75,000 Contacts: $5,760',
        price: 5760,
      },
      {
        value: '100000-6912',
        label: 'Up To 100,000 Contacts: $6,912',
        price: 6912,
      },
      {
        value: '200000-11520',
        label: 'Up To 200,000 Contacts: $11,520',
        price: 11520,
      },
      {
        value: '500000-19008',
        label: 'Up To 500,000 Contacts: $19,008',
        price: 19008,
      },
      {
        value: '750000-28224',
        label: 'Up To 750,000 Contacts: $28,224',
        price: 28224,
      },
      {
        value: '1000000-35712',
        label: 'Up To 1,000,000 Contacts: $35,712',
        price: 35712,
      },
      {
        value: '2000000-57024',
        label: 'Up To 2,000,000 Contacts: $57,024',
        price: 57024,
      },
      {
        value: '3000000-69120',
        label: 'Up To 3,000,000 Contacts: $69,120',
        price: 69120,
      },
      {
        value: '4000000-81216',
        label: 'Up To 4,000,000 Contacts: $81,216',
        price: 81216,
      },
      {
        value: '5000000-97344',
        label: 'Over 4,000,000 Contacts: $97,344',
        price: 97344,
      },
    ],
    CA: [
      {value: '1000-470', label: 'Up To 1,000 Contacts: $470', price: 470},
      {
        value: '2500-1094',
        label: 'Up To 2,500 Contacts: $1,094',
        price: 1094,
      },
      {
        value: '5000-1949',
        label: 'Up To 5,000 Contacts: $1,949',
        price: 1949,
      },
      {
        value: '10000-3120',
        label: 'Up To 10,000 Contacts: $3,120',
        price: 3120,
      },
      {
        value: '15000-4282',
        label: 'Up To 15,000 Contacts: $4,282',
        price: 4282,
      },
      {
        value: '25000-5462',
        label: 'Up To 25,000 Contacts: $5,462',
        price: 5462,
      },
      {
        value: '50000-6230',
        label: 'Up To 50,000 Contacts: $6,230',
        price: 6230,
      },
      {
        value: '75000-7786',
        label: 'Up To 75,000 Contacts: $7,786',
        price: 7786,
      },
      {
        value: '100000-9341',
        label: 'Up To 100,000 Contacts: $9,341',
        price: 9341,
      },
      {
        value: '200000-15571',
        label: 'Up To 200,000 Contacts: $15,571',
        price: 15571,
      },
      {
        value: '500000-25690',
        label: 'Up To 500,000 Contacts: $25,690',
        price: 25690,
      },
      {
        value: '750000-38141',
        label: 'Up To 750,000 Contacts: $38,141',
        price: 38141,
      },
      {
        value: '1000000-48259',
        label: 'Up To 1,000,000 Contacts: $48,259',
        price: 48259,
      },
      {
        value: '2000000-77059',
        label: 'Up To 2,000,000 Contacts: $77,059',
        price: 77059,
      },
      {
        value: '3000000-93408',
        label: 'Up To 3,000,000 Contacts: $93,408',
        price: 93408,
      },
      {
        value: '4000000-109757',
        label: 'Up To 4,000,000 Contacts: $109,757',
        price: 109757,
      },
      {
        value: '5000000-131549',
        label: 'Over 4,000,000 Contacts: $131,549',
        price: 131549,
      },
    ],
    AU: [
      {value: '1000-432', label: 'Up To 1,000 Contacts: $432', price: 432},
      {value: '2500-972', label: 'Up To 2,500 Contacts: $972', price: 972},
      {
        value: '5000-1775',
        label: 'Up To 5,000 Contacts: $1,775',
        price: 1775,
      },
      {
        value: '10000-2833',
        label: 'Up To 10,000 Contacts: $2,833',
        price: 2833,
      },
      {
        value: '15000-3900',
        label: 'Up To 15,000 Contacts: $3,900',
        price: 3900,
      },
      {
        value: '25000-4968',
        label: 'Up To 25,000 Contacts: $4,968',
        price: 4968,
      },
      {
        value: '50000-5676',
        label: 'Up To 50,000 Contacts: $5,676',
        price: 5676,
      },
      {
        value: '75000-7092',
        label: 'Up To 75,000 Contacts: $7,092',
        price: 7092,
      },
      {
        value: '100000-8507',
        label: 'Up To 100,000 Contacts: $8,507',
        price: 8507,
      },
      {
        value: '200000-14185',
        label: 'Up To 200,000 Contacts: $14,185',
        price: 14185,
      },
      {
        value: '500000-23400',
        label: 'Up To 500,000 Contacts: $23,400',
        price: 23400,
      },
      {
        value: '750000-34740',
        label: 'Up To 750,000 Contacts: $34,740',
        price: 34740,
      },
      {
        value: '1000000-43956',
        label: 'Up To 1,000,000 Contacts: $43,956',
        price: 43956,
      },
      {
        value: '2000000-70188',
        label: 'Up To 2,000,000 Contacts: $70,188',
        price: 70188,
      },
      {
        value: '3000000-85067',
        label: 'Up To 3,000,000 Contacts: $85,067',
        price: 85067,
      },
      {
        value: '4000000-99960',
        label: 'Up To 4,000,000 Contacts: $99,960',
        price: 99960,
      },
      {
        value: '5000000-119808',
        label: 'Over 4,000,000 Contacts: $119,808',
        price: 119808,
      },
    ],
    NZ: [
      {value: '1000-442', label: 'Up To 1,000 Contacts: $442', price: 442},
      {
        value: '2500-1037',
        label: 'Up To 2,500 Contacts: $1,037',
        price: 1037,
      },
      {
        value: '5000-1882',
        label: 'Up To 5,000 Contacts: $1,882',
        price: 1882,
      },
      {
        value: '10000-2976',
        label: 'Up To 10,000 Contacts: $2,976',
        price: 2976,
      },
      {
        value: '15000-4109',
        label: 'Up To 15,000 Contacts: $4,109',
        price: 4109,
      },
      {
        value: '25000-5453',
        label: 'Up To 25,000 Contacts: $5,453',
        price: 5453,
      },
      {
        value: '50000-5990',
        label: 'Up To 50,000 Contacts: $5,990',
        price: 5990,
      },
      {
        value: '75000-7469',
        label: 'Up To 75,000 Contacts: $7,469',
        price: 7469,
      },
      {
        value: '100000-8976',
        label: 'Up To 100,000 Contacts: $8,976',
        price: 8976,
      },
      {
        value: '200000-14947',
        label: 'Up To 200,000 Contacts: $14,947',
        price: 14947,
      },
      {
        value: '500000-19699',
        label: 'Up To 500,000 Contacts: $19,699',
        price: 19699,
      },
      {
        value: '750000-36518',
        label: 'Up To 750,000 Contacts: $36,518',
        price: 36518,
      },
      {
        value: '1000000-46214',
        label: 'Up To 1,000,000 Contacts: $46,214',
        price: 46214,
      },
      {
        value: '2000000-73814',
        label: 'Up To 2,000,000 Contacts: $73,814',
        price: 73814,
      },
      {
        value: '3000000-89462',
        label: 'Up To 3,000,000 Contacts: $89,462',
        price: 89462,
      },
      {
        value: '4000000-105110',
        label: 'Up To 4,000,000 Contacts: $105,110',
        price: 105110,
      },
      {
        value: '5000000-125990',
        label: 'Over 4,000,000 Contacts: $125,990',
        price: 125990,
      },
    ],
    GB: [
      {value: '1000-278', label: 'Up To 1,000 Contacts: £278', price: 278},
      {value: '2500-653', label: 'Up To 2,500 Contacts: £653', price: 653},
      {
        value: '5000-1171',
        label: 'Up To 5,000 Contacts: £1,171',
        price: 1171,
      },
      {
        value: '10000-1872',
        label: 'Up To 10,000 Contacts: £1,872',
        price: 1872,
      },
      {
        value: '15000-2582',
        label: 'Up To 15,000 Contacts: £2,582',
        price: 2582,
      },
      {
        value: '25000-3283',
        label: 'Up To 25,000 Contacts: £3,283',
        price: 3283,
      },
      {
        value: '50000-3744',
        label: 'Up To 50,000 Contacts: £3,744',
        price: 3744,
      },
      {
        value: '75000-4685',
        label: 'Up To 75,000 Contacts: £4,685',
        price: 4685,
      },
      {
        value: '100000-5626',
        label: 'Up To 100,000 Contacts: £5,626',
        price: 5626,
      },
      {
        value: '200000-9370',
        label: 'Up To 200,000 Contacts: £9,370',
        price: 9370,
      },
      {
        value: '500000-15446',
        label: 'Up To 500,000 Contacts: £15,446',
        price: 15446,
      },
      {
        value: '750000-22944',
        label: 'Up To 750,000 Contacts: £22,944',
        price: 22944,
      },
      {
        value: '1000000-29030',
        label: 'Up To 1,000,000 Contacts: £29,030',
        price: 29030,
      },
      {
        value: '2000000-46358',
        label: 'Up To 2,000,000 Contacts: £46,358',
        price: 46358,
      },
      {
        value: '3000000-56198',
        label: 'Up To 3,000,000 Contacts: £56,198',
        price: 56198,
      },
      {
        value: '4000000-66029',
        label: 'Up To 4,000,000 Contacts: £66,029',
        price: 66029,
      },
      {
        value: '5000000-79142',
        label: 'Over 4,000,000 Contacts: £79,142',
        price: 79142,
      },
    ],
  },
  'addon-5-keap-textvoice-annual': {
    US: [
      {value: '2-288', label: 'Tier 2: $288', price: 288},
      {value: '3-468', label: 'Tier 3: $468', price: 468},
      {value: '4-948', label: 'Tier 4: $948', price: 948},
      {value: '5-1668', label: 'Tier 5: $1,668', price: 1668},
      {value: '6-3348', label: 'Tier 6: $3,348', price: 3348},
    ],
    CA: [
      {value: '2-384', label: 'Tier 2: $384', price: 384},
      {value: '3-636', label: 'Tier 3: $636', price: 636},
      {value: '4-1284', label: 'Tier 4: $1,284', price: 1284},
      {value: '5-2256', label: 'Tier 5: $2,256', price: 2256},
      {value: '6-4524', label: 'Tier 6: $4,524', price: 4524},
    ],
    AU: [
      {value: '2-480', label: 'Tier 2: $480', price: 480},
      {value: '3-780', label: 'Tier 3: $780', price: 780},
      {value: '4-1560', label: 'Tier 4: $1,560', price: 1560},
      {value: '5-2760', label: 'Tier 5: $2,760', price: 2760},
      {value: '6-5580', label: 'Tier 6: $5,580', price: 5580},
    ],
    NZ: [
      {value: '2-288', label: 'Tier 2: $288', price: 288},
      {value: '3-468', label: 'Tier 3: $468', price: 468},
      {value: '4-948', label: 'Tier 4: $948', price: 948},
      {value: '5-1668', label: 'Tier 5: $1,668', price: 1668},
      {value: '6-3348', label: 'Tier 6: $3,348', price: 3348},
    ],
    GB: [
      {value: '2-228', label: 'Tier 2: £228', price: 228},
      {value: '3-372', label: 'Tier 3: £372', price: 372},
      {value: '4-744', label: 'Tier 4: £744', price: 744},
      {value: '5-1296', label: 'Tier 5: £1,296', price: 1296},
      {value: '6-2628', label: 'Tier 6: £2,628', price: 2628},
    ],
  },
  'addon-5-keap-legacy-graphly-contacts-m2m': {
    US: [
      {value: '1000-10', label: 'Up To 1,000 Contacts: $10', price: 10},
      {value: '2500-15', label: 'Up To 2,500 Contacts: $15', price: 15},
      {value: '5000-20', label: 'Up To 5,000 Contacts: $20', price: 20},
      {value: '10000-30', label: 'Up To 10,000 Contacts: $30', price: 30},
      {value: '25000-50', label: 'Up To 25,000 Contacts: $50', price: 50},
      {value: '50000-80', label: 'Up To 50,000 Contacts: $80', price: 80},
      {value: '75000-100', label: 'Up To 75,000 Contacts: $100', price: 100},
      {value: '100000-120', label: 'Up To 100,000 Contacts: $120', price: 120},
      {value: '200000-200', label: 'Up To 200,000 Contacts: $200', price: 200},
      {value: '500000-350', label: 'Up To 500,000 Contacts: $350', price: 350},
      {value: '750000-500', label: 'Up To 750,000 Contacts: $500', price: 500},
      {
        value: '1000000-700',
        label: 'Up To 1,000,000 Contacts: $700',
        price: 700,
      },
      {
        value: '2000000-950',
        label: 'Up To 2,000,000 Contacts: $950',
        price: 950,
      },
      {
        value: '3000000-1150',
        label: 'Up To 3,000,000 Contacts: $1,150',
        price: 1150,
      },
      {
        value: '4000000-1300',
        label: 'Up To 4,000,000 Contacts: $1,300',
        price: 1300,
      },
      {
        value: '5000000-1400',
        label: 'Over 4,000,000 Contacts: $1,400',
        price: 1400,
      },
    ],
    CA: [
      {value: '1000-14', label: 'Up To 1,000 Contacts: $14', price: 14},
      {value: '2500-20', label: 'Up To 2,500 Contacts: $20', price: 20},
      {value: '5000-28', label: 'Up To 5,000 Contacts: $28', price: 28},
      {value: '10000-41', label: 'Up To 10,000 Contacts: $41', price: 41},
      {value: '25000-70', label: 'Up To 25,000 Contacts: $70', price: 70},
      {value: '50000-110', label: 'Up To 50,000 Contacts: $110', price: 110},
      {value: '75000-138', label: 'Up To 75,000 Contacts: $138', price: 138},
      {value: '100000-166', label: 'Up To 100,000 Contacts: $166', price: 166},
      {value: '200000-275', label: 'Up To 200,000 Contacts: $275', price: 275},
      {value: '500000-483', label: 'Up To 500,000 Contacts: $483', price: 483},
      {value: '750000-690', label: 'Up To 750,000 Contacts: $690', price: 690},
      {
        value: '1000000-967',
        label: 'Up To 1,000,000 Contacts: $967',
        price: 967,
      },
      {
        value: '2000000-1312',
        label: 'Up To 2,000,000 Contacts: $1,312',
        price: 1312,
      },
      {
        value: '3000000-1588',
        label: 'Up To 3,000,000 Contacts: $1,588',
        price: 1588,
      },
      {
        value: '4000000-1795',
        label: 'Up To 4,000,000 Contacts: $1,795',
        price: 1795,
      },
      {
        value: '5000000-1933',
        label: 'Over 4,000,000 Contacts: $1,933',
        price: 1933,
      },
    ],
    AU: [
      {value: '1000-16.20', label: 'Up To 1,000 Contacts: $16.20', price: 16.2},
      {value: '2500-24.30', label: 'Up To 2,500 Contacts: $24.30', price: 24.3},
      {
        value: '5000-32.41',
        label: 'Up To 5,000 Contacts: $32.41',
        price: 32.41,
      },
      {
        value: '10000-48.61',
        label: 'Up To 10,000 Contacts: $48.61',
        price: 48.61,
      },
      {
        value: '25000-81.03',
        label: 'Up To 25,000 Contacts: $81.03',
        price: 81.03,
      },
      {
        value: '50000-129.65',
        label: 'Up To 50,000 Contacts: $129.65',
        price: 129.65,
      },
      {
        value: '75000-162.06',
        label: 'Up To 75,000 Contacts: $162.06',
        price: 162.06,
      },
      {
        value: '100000-194.47',
        label: 'Up To 100,000 Contacts: $194.47',
        price: 194.47,
      },
      {
        value: '200000-324.13',
        label: 'Up To 200,000 Contacts: $324.13',
        price: 324.13,
      },
      {
        value: '500000-567.21',
        label: 'Up To 500,000 Contacts: $567.21',
        price: 567.21,
      },
      {
        value: '750000-810.32',
        label: 'Up To 750,000 Contacts: $810.32',
        price: 810.32,
      },
      {
        value: '1000000-1134.44',
        label: 'Up To 1,000,000 Contacts: $1,134.44',
        price: 1134.44,
      },
      {
        value: '2000000-1539.59',
        label: 'Up To 2,000,000 Contacts: $1,539.59',
        price: 1539.59,
      },
      {
        value: '3000000-1863.72',
        label: 'Up To 3,000,000 Contacts: $1,863.72',
        price: 1863.72,
      },
      {
        value: '4000000-2106.82',
        label: 'Up To 4,000,000 Contacts: $2,106.82',
        price: 2106.82,
      },
      {
        value: '5000000-2269.98',
        label: 'Over 4,000,000 Contacts: $2,269.98',
        price: 2269.98,
      },
    ],
    NZ: [
      {value: '1000-16.20', label: 'Up To 1,000 Contacts: $16.20', price: 16.2},
      {value: '2500-24.30', label: 'Up To 2,500 Contacts: $24.30', price: 24.3},
      {
        value: '5000-32.41',
        label: 'Up To 5,000 Contacts: $32.41',
        price: 32.41,
      },
      {
        value: '10000-48.61',
        label: 'Up To 10,000 Contacts: $48.61',
        price: 48.61,
      },
      {
        value: '25000-81.03',
        label: 'Up To 25,000 Contacts: $81.03',
        price: 81.03,
      },
      {
        value: '50000-129.65',
        label: 'Up To 50,000 Contacts: $129.65',
        price: 129.65,
      },
      {
        value: '75000-162.06',
        label: 'Up To 75,000 Contacts: $162.06',
        price: 162.06,
      },
      {
        value: '100000-194.47',
        label: 'Up To 100,000 Contacts: $194.47',
        price: 194.47,
      },
      {
        value: '200000-324.13',
        label: 'Up To 200,000 Contacts: $324.13',
        price: 324.13,
      },
      {
        value: '500000-567.22',
        label: 'Up To 500,000 Contacts: $567.22',
        price: 567.22,
      },
      {
        value: '750000-810.32',
        label: 'Up To 750,000 Contacts: $810.32',
        price: 810.32,
      },
      {
        value: '1000000-1134.44',
        label: 'Up To 1,000,000 Contacts: $1,134.44',
        price: 1134.44,
      },
      {
        value: '2000000-1539.59',
        label: 'Up To 2,000,000 Contacts: $1,539.59',
        price: 1539.59,
      },
      {
        value: '3000000-1863.72',
        label: 'Up To 3,000,000 Contacts: $1,863.72',
        price: 1863.72,
      },
      {
        value: '4000000-2106.82',
        label: 'Up To 4,000,000 Contacts: $2,106.82',
        price: 2106.82,
      },
      {
        value: '5000000-2269.98',
        label: 'Over 4,000,000 Contacts: $2,269.98',
        price: 2269.98,
      },
    ],
    GB: [
      {value: '1000-8.15', label: 'Up To 1,000 Contacts: £8.15', price: 8.15},
      {
        value: '2500-12.23',
        label: 'Up To 2,500 Contacts: £12.23',
        price: 12.23,
      },
      {
        value: '5000-16.31',
        label: 'Up To 5,000 Contacts: £16.31',
        price: 16.31,
      },
      {
        value: '10000-24.46',
        label: 'Up To 10,000 Contacts: £24.46',
        price: 24.46,
      },
      {
        value: '25000-40.77',
        label: 'Up To 25,000 Contacts: £40.77',
        price: 40.77,
      },
      {
        value: '50000-65.24',
        label: 'Up To 50,000 Contacts: £65.24',
        price: 65.24,
      },
      {
        value: '75000-81.55',
        label: 'Up To 75,000 Contacts: £81.55',
        price: 81.55,
      },
      {
        value: '100000-97.86',
        label: 'Up To 100,000 Contacts: £97.86',
        price: 97.86,
      },
      {
        value: '200000-163.10',
        label: 'Up To 200,000 Contacts: £163.10',
        price: 163.1,
      },
      {
        value: '500000-285.42',
        label: 'Up To 500,000 Contacts: £285.42',
        price: 285.42,
      },
      {
        value: '750000-407.75',
        label: 'Up To 750,000 Contacts: £407.75',
        price: 407.75,
      },
      {
        value: '1000000-570.85',
        label: 'Up To 1,000,000 Contacts: £570.85',
        price: 570.85,
      },
      {
        value: '2000000-774.72',
        label: 'Up To 2,000,000 Contacts: £774.72',
        price: 774.72,
      },
      {
        value: '3000000-937.82',
        label: 'Up To 3,000,000 Contacts: £937.82',
        price: 937.82,
      },
      {
        value: '4000000-1060.15',
        label: 'Up To 4,000,000 Contacts: £1,060.15',
        price: 1060.15,
      },
      {
        value: '5000000-1141.70',
        label: 'Over 4,000,000 Contacts: £1,141.70',
        price: 1141.7,
      },
    ],
  },
  'addon-5-keap-legacy-graphly-contacts-annual': {
    US: [
      {value: '1000-102', label: 'Up To 1,000 Contacts: $102', price: 102},
      {value: '2500-153', label: 'Up To 2,500 Contacts: $153', price: 153},
      {value: '5000-204', label: 'Up To 5,000 Contacts: $204', price: 204},
      {value: '10000-306', label: 'Up To 10,000 Contacts: $306', price: 306},
      {value: '25000-510', label: 'Up To 25,000 Contacts: $510', price: 510},
      {value: '50000-816', label: 'Up To 50,000 Contacts: $816', price: 816},
      {
        value: '75000-1020',
        label: 'Up To 75,000 Contacts: $1,020',
        price: 1020,
      },
      {
        value: '100000-1224',
        label: 'Up To 100,000 Contacts: $1,224',
        price: 1224,
      },
      {
        value: '200000-1663.62',
        label: 'Up To 200,000 Contacts: $1,663.62',
        price: 1663.62,
      },
      {
        value: '500000-3570',
        label: 'Up To 500,000 Contacts: $3,570',
        price: 3570,
      },
      {
        value: '750000-5100',
        label: 'Up To 750,000 Contacts: $5,100',
        price: 5100,
      },
      {
        value: '1000000-7140',
        label: 'Up To 1,000,000 Contacts: $7,140',
        price: 7140,
      },
      {
        value: '2000000-9690',
        label: 'Up To 2,000,000 Contacts: $9,690',
        price: 9690,
      },
      {
        value: '3000000-11730',
        label: 'Up To 3,000,000 Contacts: $11,730',
        price: 11730,
      },
      {
        value: '4000000-13260',
        label: 'Up To 4,000,000 Contacts: $13,260',
        price: 13260,
      },
      {
        value: '5000000-14280',
        label: 'Over 4,000,000 Contacts: $14,280',
        price: 14280,
      },
    ],
    CA: [
      {
        value: '1000-142.80',
        label: 'Up To 1,000 Contacts: $142.80',
        price: 142.8,
      },
      {value: '2500-204', label: 'Up To 2,500 Contacts: $204', price: 204},
      {
        value: '5000-285.60',
        label: 'Up To 5,000 Contacts: $285.50',
        price: 285.6,
      },
      {
        value: '10000-418.20',
        label: 'Up To 10,000 Contacts: $418.20',
        price: 418.2,
      },
      {value: '25000-714', label: 'Up To 25,000 Contacts: $714', price: 714},
      {
        value: '50000-1122',
        label: 'Up To 50,000 Contacts: $1,122',
        price: 1122,
      },
      {
        value: '75000-1407',
        label: 'Up To 75,000 Contacts: $1,407',
        price: 1407,
      },
      {
        value: '100000-1693.20',
        label: 'Up To 100,000 Contacts: $1,693.20',
        price: 1693.2,
      },
      {
        value: '200000-2805',
        label: 'Up To 200,000 Contacts: $2,805',
        price: 2805,
      },
      {
        value: '500000-4926.60',
        label: 'Up To 500,000 Contacts: $4,926.40',
        price: 4926.6,
      },
      {
        value: '750000-7038',
        label: 'Up To 750,000 Contacts: $7,038',
        price: 7038,
      },
      {
        value: '1000000-9863.40',
        label: 'Up To 1,000,000 Contacts: $9,863.40',
        price: 9863.4,
      },
      {
        value: '2000000-13382.40',
        label: 'Up To 2,000,000 Contacts: $13,382.40',
        price: 13382.4,
      },
      {
        value: '3000000-16197.60',
        label: 'Up To 3,000,000 Contacts: $16,197.60',
        price: 16197.6,
      },
      {
        value: '4000000-18309',
        label: 'Up To 4,000,000 Contacts: $18,309',
        price: 18309,
      },
      {
        value: '5000000-19716',
        label: 'Over 4,000,000 Contacts: $19,716',
        price: 19716,
      },
    ],
    AU: [
      {
        value: '1000-165.30',
        label: 'Up To 1,000 Contacts: $165.30',
        price: 165.3,
      },
      {
        value: '2500-247.95',
        label: 'Up To 2,500 Contacts: $247.95',
        price: 247.95,
      },
      {
        value: '5000-330.61',
        label: 'Up To 5,000 Contacts: $330.61',
        price: 330.61,
      },
      {
        value: '10000-495.90',
        label: 'Up To 10,000 Contacts: $495.90',
        price: 495.9,
      },
      {
        value: '25000-826.52',
        label: 'Up To 25,000 Contacts: $826.52',
        price: 826.52,
      },
      {
        value: '50000-1322.43',
        label: 'Up To 50,000 Contacts: $1,322.43',
        price: 1322.43,
      },
      {
        value: '75000-1653.04',
        label: 'Up To 75,000 Contacts: $1,653.04',
        price: 1653.04,
      },
      {
        value: '100000-1983.64',
        label: 'Up To 100,000 Contacts: $1,983.64',
        price: 1983.64,
      },
      {
        value: '200000-3306.08',
        label: 'Up To 200,000 Contacts: $3,306.08',
        price: 3306.08,
      },
      {
        value: '500000-5785.65',
        label: 'Up To 500,000 Contacts: $5,785.65',
        price: 5785.65,
      },
      {
        value: '750000-8265.21',
        label: 'Up To 750,000 Contacts: $8,265.21',
        price: 8265.21,
      },
      {
        value: '1000000-11571.30',
        label: 'Up To 1,000,000 Contacts: $11,571.30',
        price: 11571.3,
      },
      {
        value: '2000000-15703.90',
        label: 'Up To 2,000,000 Contacts: $15,703.90',
        price: 15703.9,
      },
      {
        value: '3000000-19009.98',
        label: 'Up To 3,000,000 Contacts: $19,009.98',
        price: 19009.98,
      },
      {
        value: '4000000-21489.55',
        label: 'Up To 4,000,000 Contacts: $21,489.55',
        price: 21489.55,
      },
      {
        value: '5000000-23142.59',
        label: 'Over 4,000,000 Contacts: $23,142.59',
        price: 23142.59,
      },
    ],
    NZ: [
      {
        value: '1000-165.27',
        label: 'Up To 1,000 Contacts: $165.27',
        price: 165.27,
      },
      {
        value: '2500-247.85',
        label: 'Up To 2,500 Contacts: $247.85',
        price: 247.85,
      },
      {
        value: '5000-330.54',
        label: 'Up To 5,000 Contacts: $330.54',
        price: 330.54,
      },
      {
        value: '10000-495.81',
        label: 'Up To 10,000 Contacts: $495.81',
        price: 495.81,
      },
      {
        value: '25000-826.47',
        label: 'Up To 25,000 Contacts: $826.47',
        price: 826.47,
      },
      {
        value: '50000-1322.39',
        label: 'Up To 50,000 Contacts: $1,322.39',
        price: 1322.39,
      },
      {
        value: '75000-1653.04',
        label: 'Up To 75,000 Contacts: $1,653.04',
        price: 1653.04,
      },
      {
        value: '100000-1983.58',
        label: 'Up To 100,000 Contacts: $1,983.58',
        price: 1983.58,
      },
      {
        value: '200000-3306.09',
        label: 'Up To 200,000 Contacts: $3,306.09',
        price: 3306.09,
      },
      {
        value: '500000-5785.59',
        label: 'Up To 500,000 Contacts: $5,785.59',
        price: 5785.59,
      },
      {
        value: '750000-8265.21',
        label: 'Up To 750,000 Contacts: $8,265.21',
        price: 8265.21,
      },
      {
        value: '1000000-11571.30',
        label: 'Up To 1,000,000 Contacts: $11,571.30',
        price: 11571.3,
      },
      {
        value: '2000000-15703.85',
        label: 'Up To 2,000,000 Contacts: $15,703.85',
        price: 15703.85,
      },
      {
        value: '3000000-19009.93',
        label: 'Up To 3,000,000 Contacts: $19,009.93',
        price: 19009.93,
      },
      {
        value: '4000000-21489.55',
        label: 'Up To 4,000,000 Contacts: $21,489.55',
        price: 21489.55,
      },
      {
        value: '5000000-23142.82',
        label: 'Over 4,000,000 Contacts: $23,142.82',
        price: 23142.82,
      },
    ],
    GB: [
      {
        value: '1000-83.18',
        label: 'Up To 1,000 Contacts: £83.18',
        price: 83.18,
      },
      {
        value: '2500-124.77',
        label: 'Up To 2,500 Contacts: £124.77',
        price: 124.77,
      },
      {
        value: '5000-166.36',
        label: 'Up To 5,000 Contacts: £166.36',
        price: 166.36,
      },
      {
        value: '10000-249.54',
        label: 'Up To 10,000 Contacts: £249.54',
        price: 249.54,
      },
      {
        value: '25000-415.90',
        label: 'Up To 25,000 Contacts: £415.90',
        price: 415.9,
      },
      {
        value: '50000-665.44',
        label: 'Up To 50,000 Contacts: £665.44',
        price: 665.44,
      },
      {
        value: '75000-831.81',
        label: 'Up To 75,000 Contacts: £831.81',
        price: 831.81,
      },
      {
        value: '100000-998.17',
        label: 'Up To 100,000 Contacts: £998.17',
        price: 998.17,
      },
      {
        value: '200000-2040',
        label: 'Up To 200,000 Contacts: £2,040',
        price: 2040,
      },
      {
        value: '500000-2911.33',
        label: 'Up To 500,000 Contacts: £2,911.33',
        price: 2911.33,
      },
      {
        value: '750000-4159.05',
        label: 'Up To 750,000 Contacts: £4,159.05',
        price: 4159.05,
      },
      {
        value: '1000000-5822.67',
        label: 'Up To 1,000,000 Contacts: £5,822.67',
        price: 5822.67,
      },
      {
        value: '2000000-7902.19',
        label: 'Up To 2,000,000 Contacts: £7,902.19',
        price: 7902.19,
      },
      {
        value: '3000000-9566.81',
        label: 'Up To 3,000,000 Contacts: £9,566.81',
        price: 9566.81,
      },
      {
        value: '4000000-10813.53',
        label: 'Up To 4,000,000 Contacts: £10,813.53',
        price: 10813.53,
      },
      {
        value: '5000000-11645.34',
        label: 'Over 4,000,000 Contacts: £11,645.34',
        price: 11645.34,
      },
    ],
  },
  'addon-5-keap-legacy-plusthis-premium-trans-m2m': {
    US: [
      {
        value: '200000-199',
        label: 'Up To 200,000 Transactions: $199',
        price: 199,
      },
      {
        value: '500000-299',
        label: 'Up To 500,000 Transactions: $299',
        price: 299,
      },
      {
        value: '1000000-499',
        label: 'Up To 1,000,000 Transactions: $499',
        price: 499,
      },
      {
        value: '2000000-699',
        label: 'Up To 2,000,000 Transactions: $699',
        price: 699,
      },
    ],
    CA: [
      {
        value: '200000-269',
        label: 'Up To 200,000 Transactions: $269',
        price: 269,
      },
      {
        value: '500000-405',
        label: 'Up To 500,000 Transactions: $405',
        price: 405,
      },
      {
        value: '1000000-700',
        label: 'Up To 1,000,000 Transactions: $700',
        price: 700,
      },
      {
        value: '2000000-965',
        label: 'Up To 2,000,000 Transactions: $965',
        price: 965,
      },
    ],
    AU: [
      {
        value: '200000-323',
        label: 'Up To 200,000 Transactions: $323',
        price: 323,
      },
      {
        value: '500000-418',
        label: 'Up To 500,000 Transactions: $418',
        price: 418,
      },
      {
        value: '1000000-700',
        label: 'Up To 1,000,000 Transactions: $700',
        price: 700,
      },
      {
        value: '2000000-980',
        label: 'Up To 2,000,000 Transactions: $980',
        price: 980,
      },
    ],
    NZ: [
      {
        value: '200000-332',
        label: 'Up To 200,000 Transactions: $332',
        price: 332,
      },
      {
        value: '500000-462',
        label: 'Up To 500,000 Transactions: $462',
        price: 462,
      },
      {
        value: '1000000-770',
        label: 'Up To 1,000,000 Transactions: $770',
        price: 770,
      },
      {
        value: '2000000-1078',
        label: 'Up To 2,000,000 Transactions: $1,078',
        price: 1078,
      },
    ],
    GB: [
      {
        value: '200000-135',
        label: 'Up To 200,000 Transactions: £135',
        price: 135,
      },
      {
        value: '500000-223',
        label: 'Up To 500,000 Transactions: £223',
        price: 223,
      },
      {
        value: '1000000-372',
        label: 'Up To 1,000,000 Transactions: £372',
        price: 372,
      },
      {
        value: '2000000-520',
        label: 'Up To 2,000,000 Transactions: £520',
        price: 520,
      },
    ],
  },
  'addon-5-keap-legacy-plusthis-premium-trans-annual': {
    US: [
      {
        value: '200000-2388',
        label: 'Up To 200,000 Transactions: $2,388',
        price: 2388,
      },
      {
        value: '500000-3588',
        label: 'Up To 500,000 Transactions: $3,588',
        price: 3588,
      },
      {
        value: '1000000-5988',
        label: 'Up To 1,000,000 Transactions: $5,988',
        price: 5988,
      },
      {
        value: '2000000-8388',
        label: 'Up To 2,000,000 Transactions: $8,388',
        price: 8388,
      },
    ],
    CA: [
      {
        value: '200000-3288',
        label: 'Up To 200,000 Transactions: $3,228',
        price: 3288,
      },
      {
        value: '500000-4860',
        label: 'Up To 500,000 Transactions: $4,860',
        price: 4860,
      },
      {
        value: '1000000-8400',
        label: 'Up To 1,000,000 Transactions: $8,400',
        price: 8400,
      },
      {
        value: '2000000-11580',
        label: 'Up To 2,000,000 Transactions: $11,580',
        price: 11580,
      },
    ],
    AU: [
      {
        value: '200000-3876',
        label: 'Up To 200,000 Transactions: $3,876',
        price: 3876,
      },
      {
        value: '500000-5016',
        label: 'Up To 500,000 Transactions: $5,016',
        price: 5016,
      },
      {
        value: '1000000-8400',
        label: 'Up To 1,000,000 Transactions: $8,400',
        price: 8400,
      },
      {
        value: '2000000-11760',
        label: 'Up To 2,000,000 Transactions: $11,760',
        price: 11760,
      },
    ],
    NZ: [
      {
        value: '200000-3894',
        label: 'Up To 200,000 Transactions: $3,894',
        price: 3894,
      },
      {
        value: '500000-5544',
        label: 'Up To 500,000 Transactions: $5,544',
        price: 5544,
      },
      {
        value: '1000000-9240',
        label: 'Up To 1,000,000 Transactions: $9,240',
        price: 9240,
      },
      {
        value: '2000000-12936',
        label: 'Up To 2,000,000 Transactions: $12,936',
        price: 12936,
      },
    ],
    GB: [
      {
        value: '200000-1620',
        label: 'Up To 200,000 Transactions: £1,620',
        price: 1620,
      },
      {
        value: '500000-2676',
        label: 'Up To 500,000 Transactions: £2,676',
        price: 2676,
      },
      {
        value: '1000000-4464',
        label: 'Up To 1,000,000 Transactions: £4,464',
        price: 4464,
      },
      {
        value: '2000000-6240',
        label: 'Up To 2,000,000 Transactions: £6,240',
        price: 6240,
      },
    ],
  },
}

export function getOptionsConfig(planCode, selectedCountry) {
  if (PLAN_OPTIONS[planCode]) return PLAN_OPTIONS[planCode]
  const byCountry = PLAN_OPTIONS_BY_COUNTRY[planCode]
  // Countries without their own table (the registry countries billed in USD)
  // use the US tiers, same as the country-agnostic monthly options.
  if (byCountry) return byCountry[selectedCountry] ?? byCountry.US ?? null
  return null
}
